// extracted by mini-css-extract-plugin
export var layoutContainer = "_aw-0";
export var layoutContainerNoRounding = "_aw-6";
export var layoutContainerOpen = "_aw-5";
export var layoutContainerResizing = "_aw-1";
export var mainContent = "_aw-2";
export var resizeDivider = "_aw-3";
export var slidePanel = "_aw-4";